import React from 'react';
import { useQuery } from 'react-query';
import FormHint from '../FormHint';
import { getAveragePrice } from '../../utils/api/bookApi';
/**
 * Loads and displays the average price for a book.
 * Can be used as hint to a seller.
 * */
var AveragePricePreview = function (_a) {
    var isbn = _a.isbn;
    var data = useQuery(['books', isbn, 'averagePrice'], function () { return getAveragePrice(isbn); }).data;
    var averagePrice = data === null || data === void 0 ? void 0 : data.averagePrice;
    if (!averagePrice) {
        return null;
    }
    return React.createElement(FormHint, { showIcon: true },
        "Gjennomsnittlig bruktpris for denne boken: ",
        React.createElement("em", null,
            averagePrice,
            ",-"));
};
export default AveragePricePreview;
